import "core-js/modules/es.array.iterator.js";
export const pdfMimeTypes = ['application/pdf' // pdf
];

export const csvMimeTypes = ['text/csv' // csv
];

export const xmlMimeTypes = ['text/xml',
// xml
'application/xml',
//xml
'application/xhtml+xml' // xhtml
];

export const htmlMimeTypes = ['text/html' // html
];

export const cssMimeTypes = ['text/x-scss',
// scss
'text/x-sass',
// sass
'text/css' //css
];

export const textMimeTypes = ['text/plain' // txt
];

export const wordMimeTypes = ['application/doc',
// doc,docx
'application/ms-doc',
// doc,docx
'application/msword',
// doc,docx
'application/vnd.openxmlformats-officedocument.wordprocessingml.document' // doc,docx
];

export const powerPointMimeTypes = ['application/mspowerpoint',
// ppt,pptx
'application/powerpoint',
// ppt,pptx
'application/vnd.ms-powerpoint',
// ppt,pptx
'application/x-mspowerpoint',
// ppt,pptx
'application/vnd.openxmlformats-officedocument.presentationml.presentation' // ppt,pptx
];

export const excelMimeTypes = ['application/excel',
// xls,xlsx
'application/vnd.ms-excel',
// xls,xlsx
'application/x-excel',
// xls,xlsx
'application/x-msexcel',
// xls,xlsx
'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // xls,xlsx
];

export const libreOfficeMimeTypes = ['application/vnd.oasis.opendocument.spreadsheet',
// ods
'application/vnd.oasis.opendocument.text',
// odt
'application/vnd.oasis.opendocument.presentation' // odp
];

export const richTextMimeTypes = ['application/rtf' // rtf
];

export const jsonMimeTypes = ['application/json' // json
];

export const audioMimeTypes = ['audio/*' // wildcard all audio files
];

export const videoMimeTypes = ['video/*' // wildcard all video files
];

export const imageMimeTypes = ['image/*' // wildcard all image files
];

export const allMimeTypes = 'all';
export const defaultAcceptMimeTypes = [...pdfMimeTypes, ...csvMimeTypes, ...textMimeTypes, ...wordMimeTypes, ...excelMimeTypes, ...libreOfficeMimeTypes, ...richTextMimeTypes, ...jsonMimeTypes, ...audioMimeTypes, ...videoMimeTypes, ...imageMimeTypes];